/**
 * CalloutBox Component
 *
 * A highlighted box to draw attention to important information.
 * Use for quotes, tips, warnings, or key takeaways.
 *
 * Variants:
 * - default: Purple accent (general callouts)
 * - info: Blue tint (informational)
 * - warning: Yellow/orange tint (warnings or important notes)
 *
 * Used in: All learn pages
 */

import React from "react";
import styles from "../../styles/learn/CalloutBox.module.css";

interface CalloutBoxProps {
    children: React.ReactNode;
    variant?: "default" | "info" | "warning";
}

export default function CalloutBox({ children, variant = "default" }: CalloutBoxProps) {
    const variantClass = styles[variant] || styles.default;

    return (
        <div className={`${styles.callout} ${variantClass}`}>
            <div className={styles.calloutContent}>{children}</div>
        </div>
    );
}
